import { v } from "convex/values";
import {
  defineTableWithInternalControl,
  internalControl,
} from "../../../lib/shared/validators";

export const orderPaymentVerificationStatus = v.union(
  v.literal("pending_verification"),
  v.literal("verified"),
  v.literal("rejected"),
);

export const validatorOrderPayment = v.object({
  logisticsOrderId: v.id("logistics_orders"),
  paymentMethodId: v.id("logistics_payment_methods"),
  amount: v.number(),
  currency: v.optional(v.string()),
  reference: v.optional(v.string()),
  notes: v.optional(v.string()),
  evidenceStorageId: v.optional(v.id("_storage")),
  verificationStatus: orderPaymentVerificationStatus,
  verifiedAt: v.optional(v.number()),
  verifiedBy: v.optional(v.id("users")),
  rejectedAt: v.optional(v.number()),
  rejectedBy: v.optional(v.id("users")),
  rejectionReason: v.optional(v.string()),
  internalControl,
});

export const order_payments = defineTableWithInternalControl(
  validatorOrderPayment,
)
  .index("by_logistics_order", ["logisticsOrderId"])
  .index("by_payment_method", ["paymentMethodId"])
  .index("by_verification_status", ["verificationStatus"])
  .index("by_company_and_order", [
    "internalControl.companyId",
    "logisticsOrderId",
  ])
  .index("by_company_and_status", [
    "internalControl.companyId",
    "verificationStatus",
  ])
  .index("by_company_and_payment_method", [
    "internalControl.companyId",
    "paymentMethodId",
  ]);
